import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  display_type: "image",
  map_display_settings: {
    center: { lat: 0, lng: 0 },
    zoom: 13,
    mapId: "9cc7d3e49ca28f32"
  },
  image_display_settings: {
    image_url: ""
  },
  dashboard: {
    location: "",
    temperature: ""
  }
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setMapSettings: (state, action) => {
      return { 
        ...state, 
        ...action.payload,
        dashboard: {
          ...state.dashboard,
          ...action.payload.dashboard
        }
      };
    }
  }
});

// Selector to get location and temperature
export const selectLocationAndTemperature = (state) => ({
  location: state.settings.dashboard.location,
  temperature: state.settings.dashboard.temperature
});

export const { setMapSettings } = settingsSlice.actions;
export default settingsSlice.reducer; 